module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.21a9cc8eb22a09ae3e71.js");
};